/** @format */

import React, { useEffect, useState, useRef } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import print from "../../../../icons/print.png";
import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import axios from "axios";
import { header } from "../../../../components/api/Header";
import { NavLink } from "react-router-dom";
import $ from "jquery";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import { useReactToPrint } from "react-to-print";
import { getEnv } from "../../../../lib/env";

function ByRegion({ date, setRegionName }) {
  const conponentPDF = useRef();

  const setSearch = (text) => {
    $("tbody tr").each(function () {
      if ($(this)[0].className.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios
        .get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/suvdanfoydalanish/byregion?date=" +
            date,
          header()
        )
        .catch((e) => {
          console.log("Xato", e);
          alert("Serverga ulanishda xato!");
        });
      if (res) {
        setData(res.data);
      }
    };
    fetchData();
  }, [date]);

  let sums = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <div className='table-box-con'>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("Suvdan foydalanish", "sheet 1", "tblData")
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead'>
        <div ref={conponentPDF} style={{ width: "100%" }}>
          <table id='tblData' className='table table-bordered table-style'>
            <thead>
              <tr>
                <th rowSpan={2} scope='col'>
                  №
                </th>

                <th rowSpan={2} scope='col'>
                  Respublika va viloyatlar nomi
                </th>

                <th rowSpan={2} scope='col'>
                  Jami olingan suv
                </th>

                <th rowSpan={2} scope='col'>
                  Daryodan
                </th>

                <th colSpan={5} scope='col'>
                  Shu jumladan
                </th>

                <th rowSpan={2} scope='col'>
                  Ichki soy va daryolardan
                </th>

                <th rowSpan={2} scope='col'>
                  Yer osti suvlari
                </th>

                <th rowSpan={2} scope='col'>
                  Zovurlarda
                </th>
              </tr>

              <tr>
                <th scope='col'>Norin daryo</th>
                <th scope='col'>Qora daryo</th>
                <th scope='col'>Sirdaryo</th>
                <th scope='col'>Zarafshon</th>
                <th scope='col'>Amudaryo</th>
              </tr>
            </thead>

            {data.length > 0
              ? data.map((d, index) => {
                  if (index == 0) {
                    sums = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                  }
                  sums[0] = add(
                    sums[0],
                    add(
                      add(
                        d["norin"],
                        d["qoradaryo"],
                        d["sirdaryo"],
                        d["zarafshon"],
                        d["amudaryo"]
                      ),
                      d["ichki_soy"],
                      d["yer_osti"],
                      d["zovur"]
                    )
                  );
                  sums[1] = add(
                    sums[1],
                    add(
                      d["norin"],
                      d["qoradaryo"],
                      d["sirdaryo"],
                      d["zarafshon"],
                      d["amudaryo"]
                    )
                  );

                  sums[2] = add(sums[2], d["norin"]);
                  sums[3] = add(sums[3], d["qoradaryo"]);
                  sums[4] = add(sums[4], d["sirdaryo"]);
                  sums[5] = add(sums[5], d["zarafshon"]);
                  sums[6] = add(sums[6], d["amudaryo"]);
                  sums[7] = add(sums[7], d["ichki_soy"]);
                  sums[8] = add(sums[8], d["yer_osti"]);
                  sums[9] = add(sums[9], d["zovur"]);

                  return (
                    <tbody key={index}>
                      <tr className={d.name}>
                        <th scope='row'>{index + 1}</th>

                        <th>
                          <NavLink
                            style={{
                              color: "#222",
                            }}
                            to={"/suvdanfoydalanish/" + d.rid}
                            onClick={() => setRegionName(d.name)}>
                            {d.name}
                          </NavLink>
                        </th>

                        <td>
                          {add(
                            add(
                              d["norin"],
                              d["qoradaryo"],
                              d["sirdaryo"],
                              d["zarafshon"],
                              d["amudaryo"]
                            ),
                            d["ichki_soy"],
                            d["yer_osti"],
                            d["zovur"]
                          )}
                        </td>

                        <td>
                          {add(
                            d["norin"],
                            d["qoradaryo"],
                            d["sirdaryo"],
                            d["zarafshon"],
                            d["amudaryo"]
                          )}
                        </td>

                        <td>{d["norin"]}</td>
                        <td>{d["qoradaryo"]}</td>
                        <td>{d["sirdaryo"]}</td>
                        <td>{d["zarafshon"]}</td>
                        <td>{d["amudaryo"]}</td>
                        <td>{d["ichki_soy"]}</td>
                        <td>{d["yer_osti"]}</td>
                        <td>{d["zovur"]}</td>
                      </tr>
                    </tbody>
                  );
                })
              : null}

            <tbody>
              <tr>
                <th colSpan={2}>
                  <b>Jami</b>
                </th>

                {sums.map((s, i) => {
                  return (
                    <td key={i}>
                      <b>{s}</b>
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ByRegion;

const add = (a, b, c = 0, d = 0, e = 0) => {
  if (!a || typeof a == "undefined") {
    a = 0;
  }
  if (!b || typeof b == "undefined") {
    b = 0;
  }
  if (!c || typeof c == "undefined") {
    c = 0;
  }
  if (!d || typeof d == "undefined") {
    d = 0;
  }
  if (!e || typeof e == "undefined") {
    e = 0;
  }
  let s =
    parseFloat(a) +
    parseFloat(b) +
    parseFloat(c) +
    parseFloat(d) +
    parseFloat(e);
  if (s % 1 == 0) return s;
  return s.toFixed(2);
};
